module.exports = __webpack_public_path__ + "static/scale-model-of-tourist-information-center-in-abilene-texas-5a86533336af4e50c3117b440deb5e8e.png";